// NOTE: ALWAYS BE MINDFUL OF THE NEED TO REPLACE SPACES WITH TABS IN SOME FIELDS!!!

const loginTemplate = `<?xml version="1.0" encoding="utf-8"?>
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:ENC="http://schemas.xmlsoap.org/soap/encoding/" xmlns:tns="http://com.wms.cash" encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">
      <soapenv:Body>
        <tns:login>
          <username xsi:type="xsd:string">{{username}}</username>
          <password xsi:type="xsd:string">{{userpass}}</password>
        </tns:login>
      </soapenv:Body>
    </soapenv:Envelope>`;

export default class SoapLoginCommand {
  constructor(credentials) {
    this.credentials = credentials;
  }

  generateMessage() {
    return loginTemplate
      .replace(
        "{{username}}",
        `${this.credentials.client_id}.${this.credentials.username}`
      )
      .replace("{{userpass}}", this.credentials.userpass);
  }
}
